module.exports = __webpack_public_path__ + "img/api-portal-pricing.d9152597.svg";